export default "__VITE_ASSET___Se_CbgE__"